import { put, takeEvery, select } from "@redux-saga/core/effects";
import { updateSpinInfoHotspots } from "./sagasActions";
import { setSpinInfoHotspots } from "..";
import { getHotspotsObject } from "../selectors";
// ==================WORKERS =========================

function* updateSpinInfoHotspotsWorker(action) {
  const hotspots = yield select(getHotspotsObject);
  yield put(setSpinInfoHotspots({ hotspots }));
}

// =========== WATCHERS ============
export function* updateSpinInfoHotspotsWatcher() {
  yield takeEvery(updateSpinInfoHotspots().type, updateSpinInfoHotspotsWorker);
}
